export const nodes = [
  { id: 2721, position: [15.82, -10.77], type: "port", name: "Anhialo" },
  { id: 2720, position: [16.02, -12.58], type: "node", name: "" },
  { id: 2719, position: [16.62, -15.16], type: "node", name: "" },
  { id: 1355, position: [17.82, -17.57], type: "mine", name: "Gold Mine" },
  { id: 1354, position: [17.53, -18.85], type: "city", name: "Велико Търново", eng: "Veliko Tarnovo", walls: "80%" },
  { id: 1353, position: [17.67, -19.74], type: "node", name: "" },
  { id: 665, position: [18.33, -21.3], type: "city", name: "Ловеч", eng: "Lovech" },
  { id: 975, position: [19.89, -21.27], type: "node", name: "" },
  { id: 976, position: [21.08, -21.25], type: "port", name: "" },
  { id: 977, position: [22.55, -20.54], type: "node", name: "" },
  { id: 687, position: [24.15, -20.24], type: "city", name: "Roşiorii de Vede", eng: "Rosiorii de Vede" },
  { id: 688, position: [24.87, -21.42], type: "mine", name: "Gold Mine" },
  { id: 816, position: [25.72, -22.22], type: "city", name: "Slatina", eng: "Slatina" },
  { id: 872, position: [26.56, -21.28], type: "mine", name: "Iron Mine" },
  { id: 873, position: [27.26, -21.14], type: "city", name: "Piteşti", eng: "Pitesti" },
  { id: 874, position: [28.24, -21.51], type: "mine", name: "Stone Mine" },
  { id: 875, position: [29.58, -21.24], type: "city", name: "Curtea de Argeş", eng: "Curtea de Arges" },
  { id: 1038, position: [28.93, -20.36], type: "mine", name: "Iron Mine" },
  { id: 1036, position: [31.04, -21.48], type: "mine", name: "Gold Mine" },
  { id: 1037, position: [31.84, -21.26], type: "city", name: "Câmpulung", eng: "Campulung" },
  { id: 2781, position: [34.19, -24], type: "node", name: "" },
  { id: 2782, position: [35.62, -26.48], type: "node", name: "" },
  { id: 2783, position: [37.56, -27.6], type: "node", name: "" },
  { id: 2784, position: [38.94, -30.98], type: "node", name: "" },
  { id: 2785, position: [40.33, -33.74], type: "node", name: "" },
  { id: 2786, position: [42.4, -35.37], type: "node", name: "" },
  { id: 2787, position: [43.57, -37.1], type: "node", name: "" },
  { id: 2538, position: [44.91, -38], type: "node", name: "" },
  { id: 2741, position: [44.9, -39.79], type: "node", name: "" },
  { id: 2740, position: [44.25, -41.57], type: "node", name: "" },
  { id: 2739, position: [43.77, -43.23], type: "node", name: "" },
  { id: 2738, position: [42.46, -45.1], type: "node", name: "" },
  { id: 2537, position: [46.03, -38.07], type: "node", name: "" },
  { id: 2536, position: [47.22, -38.78], type: "node", name: "" },
  { id: 2535, position: [47.83, -39.88], type: "node", name: "" },
  { id: 2534, position: [48.55, -38.97], type: "node", name: "" },
  { id: 2533, position: [49.2, -40.55], type: "node", name: "" },
  { id: 2532, position: [50.13, -41.65], type: "node", name: "" },
  { id: 1033, position: [50.84, -42.1], type: "city", name: "Nowy Targ" },
  { id: 1032, position: [50.81, -40.5], type: "mine", name: "Salt Mine" },
  { id: 1031, position: [51.4, -38.7], type: "city", name: "Nowy Sącz", eng: "Nowy Sacz" },
  { id: 1030, position: [51.94, -37.95], type: "mine", name: "Gold Mine" },
  { id: 1029, position: [52.9, -37], type: "city", name: "Tarnów", eng: "Tarnow" },
  { id: 1035, position: [52.98, -38.87], type: "mine", name: "Salt Mine" },
  { id: 1028, position: [52.93, -40.58], type: "node", name: "" },
  { id: 1027, position: [52.92, -42.4], type: "mine", name: "Clay Mine" },
  { id: 1024, position: [53.5, -44.1], type: "city", name: "Kraków", eng: "Krakow" },
  { id: 2742, position: [51.88, -43.3], type: "node", name: "" },
  { id: 1023, position: [54.08, -44.98], type: "node", name: "" },
  { id: 1022, position: [54.5, -45.9], type: "city", name: "Wolbrom", eng: "Wolbrom" },
  { id: 1021, position: [55.05, -46.98], type: "node", name: "" },
  { id: 568, position: [56, -48.6], type: "city", name: "Częstochowa", eng: "Czestochowa" },
  { id: 569, position: [56.5, -48.4], type: "mine", name: "Gold Mine" },
  { id: 579, position: [56.97, -50.29], type: "mine", name: "Iron Mine" },
  { id: 677, position: [58.4, -50.46], type: "mine", name: "Stone Mine" },
  { id: 625, position: [59.33, -51.2], type: "city", name: "Kalisz" },
  { id: 722, position: [59.7, -49.41], type: "mine", name: "Stone Mine" },
  { id: 678, position: [59.85, -52.93], type: "mine", name: "Clay Mine" },
  { id: 679, position: [60.64, -54.63], type: "node", name: "" },
  { id: 2821, position: [60.99, -56.5], type: "mine", name: "Gold Mine" },
  { id: 680, position: [61.46, -53.82], type: "node", name: "" },
  { id: 681, position: [62.3, -53.6], type: "city", name: "Gniezno" },
  { id: 682, position: [62.4, -56.45], type: "mine", name: "Iron Mine" },
  { id: 683, position: [62.33, -58.1], type: "city", name: "Poznań", eng: "Poznan" },
  { id: 714, position: [62.41, -60.94], type: "mine", name: "Stone Mine" },
  { id: 716, position: [62.7, -63.5], type: "city", name: "Skwierzyna" },
  { id: 2733, position: [55.05, -44.96], type: "node", name: "" },
  { id: 2734, position: [55.5, -43.2], type: "node", name: "" },
  { id: 2735, position: [56.4, -42.35], type: "node", name: "" },
  { id: 2736, position: [57.34, -41.45], type: "node", name: "" },
  { id: 2737, position: [58.38, -41.52], type: "node", name: "" },
  { id: 737, position: [59.27, -40.67], type: "city", name: "Rawa" },
  { id: 738, position: [59.63, -43.16], type: "node", name: "" },
  { id: 739, position: [60.14, -45.02], type: "node", name: "" },
  { id: 724, position: [60.58, -47.57], type: "node", name: "" },
  { id: 725, position: [61.49, -45.86], type: "node", name: "" },
  { id: 726, position: [61.98, -44.85], type: "node", name: "" },
  { id: 727, position: [62.63, -43.2], type: "city", name: "Płock", eng: "Plock" },
  { id: 728, position: [62.39, -41.6], type: "mine", name: "Stone Mine" },
  { id: 729, position: [62.32, -40.55], type: "city", name: "Wyszogród", eng: "Wyszogrod" },
  { id: 740, position: [61.56, -40.81], type: "mine", name: "Iron Mine" },
  { id: 741, position: [60.55, -40.54], type: "mine", name: "Iron Mine" },
  { id: 730, position: [61.83, -39.65], type: "node", name: "" },
  { id: 731, position: [61.5, -38.8], type: "city", name: "Warszawa" },
  { id: 732, position: [60.73, -37.4], type: "mine", name: "Gold Mine" },
  { id: 733, position: [60.2, -36.05], type: "city", name: "Czersk" },
  { id: 2545, position: [59.75, -34.33], type: "node", name: "" },
  { id: 2546, position: [59.34, -32.61], type: "node", name: "" },
  { id: 2547, position: [58.82, -30.15], type: "node", name: "" },
  { id: 2548, position: [58.49, -27.4], type: "node", name: "" },
  { id: 2549, position: [58.03, -24.8], type: "node", name: "" },
  { id: 2550, position: [57.91, -22.42], type: "node", name: "" },
  { id: 2551, position: [57.5, -19.58], type: "node", name: "" },
  { id: 735, position: [59.25, -38.02], type: "mine", name: "Clay Mine" },
  { id: 1025, position: [53, -45.7], type: "mine", name: "Iron Mine" },
  { id: 1026, position: [52.8, -46.65], type: "city", name: "Oświęcim", eng: "Oswiecim" },
  { id: 1282, position: [52.42, -47.47], type: "node", name: "" },
  { id: 1281, position: [51.97, -47.74], type: "node", name: "" },
  { id: 1280, position: [51.85, -49.5], type: "node", name: "" },
  { id: 1279, position: [51.8, -51.1], type: "node", name: "" },
  { id: 1278, position: [51.48, -52.12], type: "node", name: "" },
  { id: 1277, position: [51.35, -53.89], type: "node", name: "" },
  { id: 1276, position: [50.9, -54.78], type: "node", name: "" },
  { id: 1275, position: [50.26, -55.65], type: "mine", name: "" },
  { id: 1274, position: [49.7, -57.24], type: "city", name: "Brno" },
  { id: 1273, position: [49.02, -57.26], type: "mine", name: "" },
  { id: 1272, position: [48.03, -57.41], type: "node", name: "" },
  { id: 981, position: [47.39, -58.2], type: "city", name: "Mistelbach" },
  { id: 980, position: [46.82, -58.92], type: "node", name: "" },
  { id: 1040, position: [27.23, -19.47], type: "mine", name: "Clay Mine" },
  { id: 1039, position: [28.02, -18.66], type: "city", name: "Târgovişte", eng: "Targoviste" },
  { id: 1041, position: [28.79, -17.69], type: "node", name: "" },
  { id: 1042, position: [28.82, -16.04], type: "city", name: "Târgşor", eng: "Targsor" },
  { id: 1043, position: [28.05, -15.12], type: "mine", name: "Stone Mine" },
  { id: 1044, position: [27.33, -14.28], type: "city", name: "Snagov" },
  { id: 2674, position: [28.09, -11.61], type: "node", name: "" },
  { id: 2675, position: [28.05, -9.07], type: "node", name: "" },
  { id: 2676, position: [28.21, -6.54], type: "node", name: "" },
  { id: 1763, position: [28.64, -4.04], type: "port", name: "" },
  { id: 2677, position: [30.26, -3.58], type: "node", name: "" },
  { id: 2678, position: [32.48, -3.56], type: "node", name: "" },
  { id: 2679, position: [34.13, -2.11], type: "node", name: "" },
  { id: 2680, position: [36.05, 0.55], type: "node", name: "" },
  { id: 2681, position: [37.07, 2.31], type: "node", name: "" },
  { id: 2682, position: [38.28, 3.26], type: "node", name: "" },
  { id: 2683, position: [38.3, 6.8], type: "node", name: "Great Khan's camp" },
  { id: 2748, position: [24.88, -24.04], type: "node", name: "" },
  { id: 2747, position: [24.84, -25.69], type: "node", name: "" },
  { id: 2746, position: [24.25, -27.48], type: "node", name: "" },
  { id: 2745, position: [24.01, -29.11], type: "node", name: "" },
  { id: 664, position: [18.46, -22.31], type: "mine", name: "Stone Mine" },
  { id: 663, position: [18.46, -23.92], type: "node", name: "" },
  { id: 662, position: [18.63, -25.73], type: "mine", name: "Clay Mine" },
  { id: 575, position: [19.28, -27.2], type: "city", name: "Враца", eng: "Vratsa" },
  { id: 574, position: [19.41, -28.36], type: "mine", name: "Gold Mine" },
  { id: 573, position: [20.2, -29.25], type: "city", name: "Кутловица", eng: "Kutlovitsa" },
  { id: 572, position: [20.87, -29.27], type: "mine", name: "Stone Mine" },
  { id: 571, position: [21.8, -29.4], type: "city", name: "Лом", eng: "Lom" },
  { id: 570, position: [22.59, -30.16], type: "mine", name: "Iron Mine" },
  { id: 547, position: [23.33, -31.1], type: "city", name: "Видин", eng: "Vidin" },
  { id: 548, position: [24.14, -31.87], type: "mine", name: "Gold Mine" },
  { id: 1306, position: [25.56, -32.67], type: "node", name: "" },
  { id: 1305, position: [25.86, -33.77], type: "node", name: "" },
  { id: 1304, position: [25.96, -35.17], type: "node", name: "" },
  { id: 1303, position: [26.7, -36.1], type: "node", name: "" },
  { id: 1302, position: [27.2, -37.2], type: "mine", name: "Clay Mine" },
  { id: 1216, position: [27.26, -38.86], type: "city", name: "Смедерево", eng: "Smederevo" },
  { id: 1301, position: [27.16, -39.8], type: "node", name: "" },
  { id: 1300, position: [27.335, -40.655], type: "node", name: "" },
  { id: 1388, position: [27.18, -41.68], type: "node", name: "" },
  { id: 1387, position: [27.45, -43.12], type: "node", name: "" },
  { id: 1386, position: [28.24, -44.21], type: "node", name: "" },
  { id: 1385, position: [27.435, -45.96], type: "node", name: "" },
  { id: 1384, position: [28.03, -47.545], type: "node", name: "" },
  { id: 1383, position: [28.26, -48.58], type: "node", name: "" },
  { id: 1382, position: [28.04, -50.115], type: "node", name: "" },
  { id: 1381, position: [28.33, -51.39], type: "node", name: "" },
  { id: 1380, position: [28.79, -52.66], type: "node", name: "" },
  { id: 1379, position: [29.13, -53.74], type: "node", name: "" },
  { id: 1378, position: [29.55, -55.46], type: "node", name: "" },
  { id: 1377, position: [29.66, -56.38], type: "node", name: "" },
  { id: 1376, position: [30.3, -57.58], type: "node", name: "" },
  { id: 1375, position: [31.05, -59], type: "node", name: "" },
  { id: 1374, position: [32.02, -59.9], type: "node", name: "" },
  { id: 1269, position: [32.46, -60.92], type: "node", name: "" },
  { id: 1270, position: [31.83, -61.7], type: "mine", name: "Clay Mine" },
  { id: 1362, position: [31.4, -62.6], type: "city", name: "Dubovac" },
  { id: 1271, position: [31.09, -63.48], type: "mine", name: "Stone Mine" },
  { id: 817, position: [30.35, -65.1], type: "city", name: "Vrbovsko" },
  { id: 818, position: [30.56, -67.27], type: "mine", name: "Gold Mine" },
  { id: 1020, position: [30.38, -68.34], type: "city", name: "Rijeka" },
  { id: 2774, position: [28.76, -70.45], type: "node", name: "" },
  { id: 1350, position: [27.4, -70.95], type: "city", name: "Pola" },
  { id: 1349, position: [28.3, -71.95], type: "mine", name: "Gold Mine" },
  { id: 1348, position: [29.6, -72], type: "city", name: "Parenzo" },
  { id: 1347, position: [30.96, -72.14], type: "mine", name: "Clay Mine" },
  { id: 1346, position: [31.28, -71.3], type: "node", name: "" },
  { id: 1351, position: [31.04, -70.45], type: "node", name: "" },
  { id: 1352, position: [31.22, -69.53], type: "mine", name: "Iron Mine" },
  { id: 1345, position: [32.05, -72.33], type: "mine", name: "Salt Mine" },
  { id: 1343, position: [33.45, -73], type: "city", name: "Udine" },
  { id: 2286, position: [33.97, -72.25], type: "node", name: "" },
  { id: 2287, position: [34.05, -71.24], type: "node", name: "" },
  { id: 2288, position: [34.68, -70.63], type: "node", name: "" },
  { id: 2289, position: [34.96, -69.72], type: "node", name: "" },
  { id: 2290, position: [34.75, -68.57], type: "node", name: "" },
  { id: 2291, position: [35, -67.62], type: "node", name: "" },
  { id: 2151, position: [35.55, -66.13], type: "city", name: "Celje" },
  { id: 2284, position: [36.1, -65.2], type: "node", name: "" },
  { id: 2285, position: [36.4, -63.35], type: "node", name: "" },
  { id: 1186, position: [36.9, -62.55], type: "city", name: "Marburg an der Drau" },
  { id: 1185, position: [38.3, -63.43], type: "mine", name: "Stone Mine" },
  { id: 1183, position: [39.6, -63.6], type: "city", name: "Graz" },
  { id: 1182, position: [40.37, -64.38], type: "mine", name: "Iron Mine" },
  { id: 1181, position: [41.14, -64.24], type: "city", name: "Bruck an der Mur" },
  { id: 1187, position: [41.12, -66.07], type: "mine", name: "Stone Mine" },
  { id: 1188, position: [41.75, -67.05], type: "mine", name: "Gold Mine" },
  { id: 1189, position: [42.43, -68.07], type: "city", name: "Rottenmann" },
  { id: 1190, position: [43.09, -66.92], type: "mine", name: "Iron Mine" },
  { id: 1191, position: [43.67, -67.10], type: "node", name: "" },
  { id: 1192, position: [44.29, -67.91], type: "mine", name: "Stone Mine" },
  { id: 692, position: [44.95, -67.83], type: "city", name: "Linz" },
  { id: 693, position: [44.95, -66.28], type: "mine", name: "Iron Mine" },
  { id: 694, position: [44.93, -65.2], type: "city", name: "Amstetten" },
  { id: 695, position: [44.99, -63.47], type: "mine", name: "Gold Mine" },
  { id: 696, position: [44.88, -61.8], type: "node", name: "" },
  { id: 697, position: [44.9, -60.06], type: "mine", name: "Stone Mine" },
  { id: 691, position: [45.47, -68.76], type: "port", name: "" },
  { id: 611, position: [46.16, -70], type: "city", name: "Passau" },
  { id: 1180, position: [41.6, -63.29], type: "mine", name: "Stone Mine" },
  { id: 1179, position: [42.25, -62.6], type: "node", name: "" },
  { id: 1178, position: [42.36, -61.64], type: "mine", name: "Iron Mine" },
  { id: 983, position: [43.02, -60], type: "city", name: "Ternitz" },
  { id: 982, position: [44.3, -59.9], type: "mine", name: "Clay Mine" },
  { id: 698, position: [45.6, -59], type: "city", name: "Wien" },
  { id: 1283, position: [44.97, -57.52], type: "node", name: "" },
  { id: 1284, position: [45.09, -55.48], type: "node", name: "" },
  { id: 1285, position: [44.18, -55], type: "node", name: "" },
  { id: 1286, position: [43.5, -54.72], type: "node", name: "" },
  { id: 877, position: [43.125, -54.15], type: "city", name: "Győr", eng: "Gyor" },
  { id: 878, position: [42.9, -52.85], type: "mine", name: "Salt Mine?" },
  { id: 1017, position: [43.08, -52], type: "node", name: "" },
  { id: 1018, position: [43.08, -50.3], type: "city", name: "Esztergom" },
  { id: 1019, position: [43.2, -49.2], type: "mine", name: "Mine" },
  { id: 1287, position: [42.34, -47.65], type: "node", name: "" },
  { id: 1288, position: [41.08, -47.82], type: "node", name: "" },
  { id: 1289, position: [39.8, -47.8], type: "node", name: "" },
  { id: 1290, position: [38.32, -47.78], type: "node", name: "" },
  { id: 1291, position: [37, -47.88], type: "node", name: "" },
  { id: 1292, position: [35.4, -48.18], type: "node", name: "" },
  { id: 1293, position: [34.1, -48.72], type: "node", name: "" },
  { id: 1294, position: [32.75, -47.73], type: "node", name: "" },
  { id: 1295, position: [31.85, -47.5], type: "node", name: "" },
  { id: 1296, position: [30.66, -45.88], type: "node", name: "" },
  { id: 1297, position: [30.27, -44.13], type: "node", name: "" },
  { id: 1298, position: [29.8, -42.5], type: "node", name: "" },
  { id: 1299, position: [28.55, -41.7], type: "node", name: "" },
  { id: 1363, position: [41.64, -49.25], type: "mine", name: "Mine" },
  { id: 1364, position: [41.1, -50.45], type: "city", name: "Székesfehérvár", eng: "Szekesfehervar" },
  { id: 1365, position: [39.8, -51.15], type: "mine", name: "Mine" },
  { id: 1366, position: [39, -52.05], type: "node", name: "" },
  { id: 1367, position: [38.3, -53.7], type: "node", name: "" },
  { id: 1368, position: [37.6, -55.56], type: "node", name: "" },
  { id: 1369, position: [37.48, -57.15], type: "node", name: "" },
  { id: 1370, position: [36.4, -58.29], type: "node", name: "" },
  { id: 1371, position: [34.8, -59.07], type: "node", name: "" },
  { id: 1372, position: [34.25, -59.82], type: "node", name: "" },
  { id: 1373, position: [33.37, -60.1], type: "node", name: "" },
  { id: 2152, position: [34.92, -65.27], type: "mine", name: "Gold Mine" },
  { id: 2280, position: [34.6, -64.2], type: "node", name: "" },
  { id: 2281, position: [34.2, -63.3], type: "node", name: "" },
  { id: 2282, position: [34.08, -62.35], type: "node", name: "" },
  { id: 1268, position: [33.48, -61.63], type: "node", name: "" },
  { id: 1267, position: [34.7, -60.9], type: "node", name: "" },
  { id: 1266, position: [35.6, -60.78], type: "node", name: "" },
  { id: 1265, position: [36.15, -61.83], type: "node", name: "" },
  { id: 2776, position: [33.5, -66.84], type: "node", name: "" },
  { id: 2775, position: [31.93, -68], type: "node", name: "" },
  { id: 1342, position: [32.67, -74.05], type: "mine", name: "Iron Mine" },
  { id: 1340, position: [32.4, -75.5], type: "city", name: "Portogruaro" },
  { id: 1339, position: [32.6, -76.55], type: "mine", name: "Clay Mine" },
  { id: 1337, position: [31.85, -77.8], type: "city", name: "Treviso" },
  { id: 1336, position: [31.18, -77.55], type: "mine", name: "Stone Mine" },
  { id: 1335, position: [30.4, -77.25], type: "city", name: "Venezia" },
  { id: 1344, position: [34.05, -73.1], type: "mine", name: "Gold Mine" },
  { id: 1389, position: [27.17, -51.06], type: "node", name: "" },
  { id: 1390, position: [26.35, -51.96], type: "node", name: "" },
  { id: 1391, position: [25.57, -52.76], type: "node", name: "" },
  { id: 1392, position: [24.14, -52.18], type: "mine", name: "Clay Mine" },
  { id: 2329, position: [25.68, -39.12], type: "mine", name: "Iron Mine" },
  { id: 2328, position: [24.18, -39.68], type: "city", name: "Рудник", eng: "Rudnik" },
  { id: 2531, position: [23.13, -39.92], type: "node", name: "" },
  { id: 2530, position: [22.5, -41.52], type: "node", name: "" },
  { id: 2529, position: [22.35, -43.22], type: "node", name: "" },
  { id: 2528, position: [22.42, -44.77], type: "node", name: "" },
  { id: 2527, position: [21.58, -46.04], type: "node", name: "" },
  { id: 2526, position: [20.66, -47.65], type: "node", name: "" },
  { id: 2525, position: [20.96, -49.34], type: "node", name: "" },
  { id: 2327, position: [23.38, -37.95], type: "mine", name: "Gold Mine" },
  { id: 1404, position: [23.28, -36.2], type: "city", name: "Јагодна", eng: "Jagodna" },
  { id: 2743, position: [23.24, -34.51], type: "node", name: "" },
  { id: 2744, position: [23.44, -32.79], type: "node", name: "" },
  { id: 1217, position: [26.74, -37.96], type: "mine", name: "Iron Mine" },
  { id: 1403, position: [24.92, -37.06], type: "node", name: "" },
  { id: 653, position: [18.4, -27.44], type: "node", name: "" },
  { id: 654, position: [17.75, -28.55], type: "node", name: "" },
  { id: 655, position: [16.74, -29.25], type: "city", name: "София", eng: "Sofia" },
  { id: 656, position: [15.82, -28.36], type: "mine", name: "Iron Mine" },
  { id: 657, position: [15.19, -27.4], type: "city", name: "Самоков", eng: "Samokov" },
  { id: 2716, position: [12.49, -27.49], type: "node", name: "" },
  { id: 2717, position: [10.65, -27.38], type: "node", name: "" },
  { id: 2718, position: [8.95, -27.54], type: "node", name: "" },
  { id: 666, position: [7.28, -27.5], type: "city", name: "Σέρρες", eng: "Serres" },
  { id: 667, position: [6.6, -29.43], type: "mine", name: "Gold Mine" },
  { id: 876, position: [6.4, -30.73], type: "city", name: "Κιλκίς", eng: "Kilkis" },
  { id: 1402, position: [12.71, -45.68], type: "mine", name: "Clay Mine" },
  { id: 1401, position: [13.98, -46.035], type: "node", name: "" },
  { id: 1400, position: [14.96, -46.87], type: "node", name: "" },
  { id: 1399, position: [16, -47.52], type: "node", name: "" },
  { id: 1398, position: [17.45, -48.31], type: "node", name: "" },
  { id: 1397, position: [18.26, -49.49], type: "node", name: "" },
  { id: 1396, position: [19.41, -50.11], type: "node", name: "" },
  { id: 1395, position: [20.81, -51.23], type: "node", name: "" },
  { id: 1394, position: [21.83, -51.865], type: "mine", name: "Gold Mine" },
  { id: 1393, position: [22.37, -52.94], type: "city", name: "Zenica" },
  { id: 2522, position: [21.48, -54.78], type: "node", name: "" },
  { id: 2523, position: [20.22, -55.48], type: "mine", name: "Iron Mine" },
  { id: 2524, position: [19.25, -56.5], type: "city", name: "Brštanik", eng: "Brstanik" },
  { id: 2672, position: [18.28, -57.96], type: "mine", name: "Stone Mine" },
  { id: 1314, position: [11.64, -44.92], type: "city", name: "Lezhë", eng: "Lezhe" },
  { id: 1315, position: [11.44, -43.36], type: "mine", name: "Gold Mide" },
  { id: 2521, position: [10.92, -42.59], type: "node", name: "" },
  { id: 2520, position: [10.06, -41.69], type: "node", name: "" },
  { id: 2519, position: [9.77, -40.51], type: "node", name: "" },
  { id: 2518, position: [8.95, -39.68], type: "node", name: "" },
  { id: 2517, position: [9.14, -38.24], type: "node", name: "" },
  { id: 2516, position: [8.16, -37.13], type: "node", name: "" },
  { id: 2515, position: [8.05, -35.49], type: "node", name: "" },
  { id: 2514, position: [7.37, -34.37], type: "node", name: "" },
  { id: 2513, position: [6.62, -33.5], type: "node", name: "" },
  { id: 2512, position: [6.27, -31.96], type: "node", name: "" },
  { id: 2511, position: [5.37, -31.95], type: "node", name: "" },
  { id: 2510, position: [4.73, -33.74], type: "node", name: "" },
  { id: 2509, position: [4.75, -35.56], type: "node", name: "" },
  { id: 2508, position: [5.565, -37.24], type: "node", name: "" },
  { id: 2507, position: [4.59, -39.05], type: "node", name: "" },
  { id: 2506, position: [5.63, -40.6], type: "node", name: "" },
  { id: 2505, position: [5.69, -42.2], type: "node", name: "" },
  { id: 2504, position: [4.6, -43.32], type: "node", name: "" },
  { id: 2503, position: [5.45, -45.03], type: "mine", name: "Iron Mine" },
  { id: 2502, position: [5.55, -46.63], type: "city", name: "Dyrrah" },
  { id: 2501, position: [8, -46.48], type: "mine", name: "Stone Mine" },
  { id: 2500, position: [9.72, -45.12], type: "node", name: "" },
  { id: 1015, position: [6.32, -27.42], type: "mine", name: "Iron Mine" },
  { id: 1016, position: [5.42, -27.62], type: "city", name: "Άγιος Γεώργιος", eng: "Agios Georgios" },
  { id: 1308, position: [8.02, -24.93], type: "mine", name: "Clay Mine" },
  { id: 1310, position: [7, -23.07], type: "node", name: "" },
  { id: 1312, position: [7.28, -20.43], type: "node", name: "" },
  { id: 860, position: [6.22, -17.89], type: "node", name: "" },
  { id: 859, position: [7.09, -16.17], type: "mine", name: "Stone Mine" },
  { id: 658, position: [14.2, -26.46], type: "mine", name: "Iron Mine" },
  { id: 659, position: [13.45, -24.82], type: "node", name: "" },
  { id: 660, position: [13.52, -23.82], type: "node", name: "" },
  { id: 661, position: [12.35, -22.24], type: "node", name: "" },
  { id: 970, position: [12.67, -20.46], type: "node", name: "" },
  { id: 971, position: [11.44, -19.54], type: "node", name: "" },
  { id: 972, position: [11.93, -18.6], type: "node", name: "" },
  { id: 973, position: [11.6, -17.8], type: "city", name: "Harmanli" },
  { id: 974, position: [10.6, -16.92], type: "mine", name: "Stone Mine" },
  { id: 824, position: [10.8, -15.1], type: "city", name: "Edirne" },
  { id: 825, position: [9.225, -14.45], type: "mine", name: "Clay Mine" },
  { id: 795, position: [7.3, -14.37], type: "city", name: "Keşan", eng: "Kesan" },
  { id: 794, position: [6.635, -13.25], type: "mine", name: "Stone Mine" },
  { id: 793, position: [6.335, -11.7], type: "city", name: "Şarköy", eng: "Sarkoy" },
  { id: 720, position: [5.81, -12.6], type: "mine", name: "Gold Mine" },
  { id: 719, position: [5.45, -13.4], type: "city", name: "Gelibolu" },
  { id: 950, position: [4.5, -13.6], type: "node", name: "" },
  { id: 951, position: [3.6, -15.05], type: "city", name: "Çanakkale", eng: "Canakkale" },
  { id: 952, position: [2.8, -15.12], type: "mine", name: "Gold Mine" },
  { id: 953, position: [2, -15.12], type: "city", name: "Ezine" },
  { id: 954, position: [1.15, -15.14], type: "mine", name: "Stone Mine" },
  { id: 1218, position: [0.42, -14.23], type: "mine", name: "" },
  { id: 955, position: [0.3, -12.38], type: "city", name: "Edremit" },
  { id: 958, position: [0.14, -11.39], type: "mine", name: "Iron Mine" },
  { id: 959, position: [0.3, -10.7], type: "city", name: "Balya" },
  { id: 960, position: [0.11, -9.93], type: "node", name: "" },
  { id: 961, position: [0.4, -9], type: "city", name: "Balikesir" },
  { id: 967, position: [0.23, -8.12], type: "node", name: "" },
  { id: 968, position: [0.55, -7.12], type: "mine", name: "Gold Mine" },
  { id: 969, position: [0.28, -6.36], type: "city", name: "Dursunbey" },
  { id: 1223, position: [-0.5, -5.26], type: "mine", name: "Stone Mine" },
  { id: 1224, position: [-0.7, -3.74], type: "city", name: "Tavşanlı", eng: "Tavsanli" },
  { id: 1242, position: [0.24, -3.76], type: "node", name: "" },
  { id: 1243, position: [1.02, -2.92], type: "node", name: "" },
  { id: 1244, position: [1.94, -2.82], type: "city", name: "Inegöl", eng: "Inegol" },
  { id: 1245, position: [2.1, -3.8], type: "mine", name: "Iron Mine" },
  { id: 1247, position: [2.92, -4.48], type: "node", name: "" },
  { id: 1246, position: [3.12, -5.55], type: "node", name: "" },
  { id: 1221, position: [2.8, -7.05], type: "city", name: "Karacabey" },
  { id: 1222, position: [3, -8.21], type: "node", name: "" },
  { id: 966, position: [3.62, -8.94], type: "city", name: "Bandırma", eng: "Bandirma" },
  { id: 965, position: [3.17, -9.96], type: "mine", name: "Iron Mine" },
  { id: 964, position: [2.9, -10.75], type: "city", name: "Gönen", eng: "Gonen" },
  { id: 1241, position: [2.73, -11.59], type: "mine", name: "Stone Mine" },
  { id: 1240, position: [2.89, -12.45], type: "city", name: "Çan", eng: "Can" },
  { id: 1239, position: [3.18, -14.12], type: "mine", name: "Gold Mine" },
  { id: 1248, position: [3.845, -3.72], type: "mine", name: "Iron Mine" },
  { id: 1249, position: [4.64, -3.72], type: "city", name: "Gemlik" },
  { id: 1264, position: [-0.7, -8.92], type: "mine", name: "" },
  { id: 1219, position: [1.24, -8.21], type: "node", name: "" },
  { id: 1220, position: [2.02, -7.94], type: "node", name: "" },
  { id: 962, position: [1.32, -10], type: "node", name: "" },
  { id: 963, position: [2.19, -10.8], type: "node", name: "" },
  { id: 956, position: [-0.44, -13.56], type: "mine", name: "Stone Mine" },
  { id: 957, position: [-1.56, -14.14], type: "city", name: "Ayvalık", eng: "Ayvalik" },
  { id: 823, position: [10.78, -13.33], type: "mine", name: "Iron Mine" },
  { id: 822, position: [10.43, -11.63], type: "city", name: "Kirklareli" },
  { id: 821, position: [8.9, -11.4], type: "mine", name: "Iron Mine" },
  { id: 820, position: [7.65, -10.8], type: "city", name: "Tekirdağ", eng: "Tekirdag" },
  { id: 819, position: [7.31, -11.54], type: "node", name: "" },
  { id: 861, position: [8.1, -9.97], type: "mine", name: "Gold Mine" },
  { id: 862, position: [9, -9.85], type: "node", name: "Türbedere", eng: "Turbedere" },
  { id: 2810, position: [15.87, -19.61], type: "node", name: "" },
  { id: 2811, position: [14.24, -18.71], type: "node", name: "" },
  { id: 2812, position: [13.39, -16.97], type: "node", name: "" },

  // Italy
  { id: 1153, position: [8.2, -68.65], type: "city", name: "Capua" },
  { id: 1152, position: [8.9, -69.64], type: "mine", name: "Iron Mine" },
  { id: 1151, position: [9.3, -70.6], type: "city", name: "Sessa Aurunca" },
  { id: 1150, position: [8.93, -71.32], type: "node", name: "" },
  { id: 1145, position: [9.2, -72.2], type: "city", name: "Gaeta" },
  { id: 1144, position: [8.91, -73.1], type: "mine", name: "Stone Mine" },
  { id: 1143, position: [9, -74.1], type: "city", name: "Terracina" },
  { id: 1146, position: [9.86, -71.31], type: "mine", name: "Clay Mine" },
  { id: 1148, position: [10.75, -71.41], type: "mine", name: "Gold Mine" },
  { id: 1147, position: [10.85, -70.35], type: "city", name: "Pontecorvo" },
  { id: 1149, position: [11.7, -72.3], type: "city", name: "Sora" },
  { id: 1193, position: [12.45, -73.15], type: "node", name: "" },
  { id: 1194, position: [13.3, -73.1], type: "city", name: "Avezzano" },
  { id: 1206, position: [13.29, -72.12], type: "mine", name: "Gold Mine" },
  { id: 1205, position: [13.3, -70.4], type: "city", name: "Sulmona" },
  { id: 1204, position: [14.35, -70.55], type: "mine", name: "Iron Mine" },
  { id: 1203, position: [15.05, -69.95], type: "city", name: "Chieti" },
  { id: 1202, position: [15.78, -70.65], type: "node", name: "" },
  { id: 1201, position: [16.6, -70.8], type: "city", name: "Silvi" },
  { id: 1200, position: [16.95, -71.35], type: "mine", name: "Stone Mine" },
  { id: 1199, position: [16.75, -72.5], type: "city", name: "Teramo" },
  { id: 1207, position: [16.1, -73.07], type: "mine", name: "Iron Mine" },
  { id: 1198, position: [15.8, -74.2], type: "city", name: "L'Aquila", eng: "L'Aquila" },
  { id: 1197, position: [15.12, -74.98], type: "mine", name: "Stone Mine" },
  { id: 1196, position: [14.1, -75.2], type: "city", name: "Tagliacozzo" },
  { id: 1195, position: [13.34, -74.1], type: "mine", name: "Gold Mine" },
  { id: 1238, position: [16.22, -74.98], type: "mine", name: "Clay Mine" },
  { id: 1237, position: [16.96, -75.6], type: "node", name: "" },
  { id: 1236, position: [16.65, -76.66], type: "node", name: "" },
  { id: 1235, position: [16.98, -77.49], type: "node", name: "" },
  { id: 1234, position: [17.72, -78.14], type: "node", name: "" },
  { id: 1215, position: [18.45, -78.53], type: "city", name: "Montepulciano" },
  { id: 2777, position: [18.53, -79.34], type: "node", name: "" },
  { id: 1232, position: [18.44, -80.2], type: "city", name: "Siena" },
  { id: 1231, position: [17.56, -80.95], type: "mine", name: "Gold Mine" },
  { id: 1226, position: [16.67, -81.03], type: "city", name: "Grosseto" },
  { id: 1227, position: [15.78, -81.06], type: "mine", name: "Iron Mine" },
  { id: 1228, position: [14.95, -80.9], type: "city", name: "Orbetello" },
  { id: 1229, position: [16.89, -80.05], type: "mine", name: "Stone Mine" },
  { id: 1230, position: [16.73, -79.2], type: "city", name: "Santa Fiora" },
  { id: 1225, position: [16.74, -82.02], type: "node", name: "" },
  { id: 1209, position: [17.55, -82.6], type: "city", name: "Piombino" },
  { id: 1208, position: [18.53, -82.61], type: "mine", name: "Stone Mine" },
  { id: 1136, position: [19.22, -81.73], type: "city", name: "Volterra" },
  { id: 1135, position: [19.17, -83.05], type: "mine", name: "Gold Mine" },
  { id: 1134, position: [19.19, -84.5], type: "city", name: "Livorno" },
  { id: 1133, position: [20.1, -84.45], type: "node", name: "" },
  { id: 1132, position: [20.9, -84.55], type: "city", name: "Pisa" },
  { id: 1137, position: [20.98, -83.46], type: "mine", name: "Iron Mine" },
  { id: 1138, position: [20.91, -82], type: "city", name: "San Miniato" },
  { id: 1139, position: [20.98, -81.03], type: "node", name: "" },
  { id: 1140, position: [20.83, -79.95], type: "city", name: "Firenze" },
  { id: 1210, position: [20.17, -79.3], type: "mine", name: "Clay Mine" },
  { id: 1211, position: [19.93, -78.68], type: "city", name: "Montevarchi" },
  { id: 1233, position: [19.41, -80.1], type: "node", name: "" },
  { id: 1212, position: [19.09, -77.7], type: "mine", name: "Gold Mine" },
  { id: 1213, position: [19.15, -76.5], type: "city", name: "Arezzo" },
  { id: 1214, position: [18.42, -77.51], type: "mine", name: "Iron Mine" },
  { id: 1141, position: [21.74, -80.25], type: "mine", name: "Stone Mine" },
  { id: 1142, position: [22.49, -81.5], type: "city", name: "Pistoia" },
  { id: 2573, position: [23.45, -81.33], type: "node", name: "" },
  { id: 2572, position: [24.79, -81.87], type: "node", name: "" },
  { id: 857, position: [25.83, -82.99], type: "city", name: "Modena" },
  { id: 856, position: [26.53, -81.92], type: "mine", name: "Clay Mine" },
  { id: 854, position: [27.24, -81.54], type: "city", name: "Mirandola" },
  { id: 855, position: [27.39, -82.79], type: "mine", name: "Gold Mine" },
  { id: 850, position: [27.23, -83.75], type: "city", name: "Guastalla" },
  { id: 858, position: [26.48, -83.69], type: "node", name: "" },
  { id: 849, position: [27.40, -84.68], type: "node", name: "" },
  { id: 846, position: [26.38, -84.98], type: "city", name: "Parma" },
  { id: 847, position: [25.67, -85.48], type: "mine", name: "Gold Mine" },
  { id: 848, position: [25.68, -86.64], type: "city", name: "Fornovo" },
  { id: 945, position: [24.91, -85.25], type: "node", name: "" },
  { id: 944, position: [24.18, -84.56], type: "node", name: "" },
  { id: 946, position: [25.08, -83.89], type: "mine", name: "Iron Mine" },
  { id: 943, position: [23.42, -84.64], type: "mine", name: "Stone Mine" },
  { id: 1131, position: [21.69, -84.57], type: "node", name: "" },
  { id: 942, position: [22.47, -85.25], type: "city", name: "Massa" },
  { id: 941, position: [23.35, -86.42], type: "node", name: "" },
  { id: 940, position: [24.86, -86.38], type: "node", name: "" },
  { id: 851, position: [28.12, -83.82], type: "mine", name: "Iron Mine" },
  { id: 853, position: [27.85, -82.13], type: "mine", name: "Stone Mine" },
  { id: 852, position: [28.83, -82.64], type: "city", name: "Mantua" },
  { id: 1329, position: [29.57, -82.17], type: "node", name: "" },
  { id: 1330, position: [30.32, -82.03], type: "city", name: "Verona" },
  { id: 1332, position: [30.64, -80.42], type: "mine", name: "Stone Mine" },
  { id: 1333, position: [30.37, -79.15], type: "city", name: "Padova" },
  { id: 1334, position: [30.19, -78.21], type: "mine", name: "Salt Mine" },
  { id: 1331, position: [31.24, -81.97], type: "mine", name: "Stone Mine" },

  //Germany
  { id: 939, position: [24.08, -86.85], type: "city", name: "La Spezia" },
  { id: 938, position: [24.74, -88.16], type: "mine", name: "Gold Mine" },
  { id: 937, position: [24.94, -89.23], type: "city", name: "Chiavari" },
  { id: 936, position: [25.58, -90.47], type: "node", name: "" },
  { id: 931, position: [25.70, -91.59], type: "city", name: "Genova" },
  { id: 932, position: [24.95, -92.32], type: "mine", name: "Stone Mine" },
  { id: 933, position: [24.16, -92.35], type: "city", name: "Savona" },
  { id: 934, position: [23.99, -93.49], type: "node", name: "" },
  { id: 935, position: [23.25, -94.22], type: "city", name: "Albenga" },
  { id: 947, position: [23.53, -95.13], type: "mine", name: "Iron Mine" },
  { id: 948, position: [23.26, -96.27], type: "city", name: "Ventimiglia" },
  { id: 845, position: [26.69, -85.99], type: "node", name: "" },
  { id: 844, position: [27.12, -86.38], type: "node", name: "" },
  { id: 797, position: [28, -86.28], type: "city", name: "Piacenza" },
  { id: 796, position: [28.87, -86.45], type: "mine", name: "Stone Mine" },
  { id: 2779, position: [30.22, -83.79], type: "node", name: "" },
  { id: 2778, position: [30.20, -86.22], type: "node", name: "" },
  { id: 578, position: [29.58, -87.37], type: "city", name: "Lodi" },
  { id: 673, position: [30.46, -88.54], type: "mine", name: "" },
  { id: 671, position: [31.15, -89.93], type: "city", name: "Milano" },
  { id: 674, position: [32.14, -90.49], type: "mine", name: "Iron Mine" },
  { id: 675, position: [33.31, -90.66], type: "city", name: "Como" },
  { id: 2780, position: [27.22, -88.93], type: "node", name: "" },
  { id: 567, position: [28.85, -88.27], type: "mine", name: "Gold Mine" },
  { id: 566, position: [28.79, -89.80], type: "city", name: "Pavia" },
  { id: 672, position: [30.14, -89.91], type: "node", name: "" },
  { id: 668, position: [29.54, -91.43], type: "mine", name: "Clay Mine" },
  { id: 669, position: [30.31, -92.54], type: "city", name: "Novara" },
  { id: 670, position: [30.51, -91.01], type: "mine", name: "Stone Mine" },
  { id: 930, position: [26.45, -92.33], type: "mine", name: "Gold Mine" },
  { id: 929, position: [27.07, -92.26], type: "node", name: "" },
  { id: 788, position: [28, -92.40], type: "city", name: "Alessandria" },
  { id: 787, position: [28.14, -91.51], type: "mine", name: "Iron Mine" },
  { id: 789, position: [28.08, -93.36], type: "node", name: "" },
  { id: 790, position: [28.87, -94.35], type: "node", name: "" },
  { id: 277, position: [29.59, -95.26], type: "port", name: "" },
  { id: 2766, position: [32.52, -83.79], type: "node", name: "" },
  { id: 2765, position: [34.11, -84.67], type: "node", name: "" },
  { id: 2764, position: [35.59, -86.38], type: "node", name: "" },
  { id: 2763, position: [37.06, -87.40], type: "node", name: "" },
  { id: 2762, position: [38.92, -87.39], type: "node", name: "" },
  { id: 2761, position: [40.37, -88.30], type: "node", name: "" },
  { id: 539, position: [41.7, -87.16], type: "city", name: "Lindau" },
  { id: 538, position: [42.38, -87.23], type: "mine", name: "Iron Mine" },
  { id: 474, position: [43, -87.2], type: "city", name: "Ravensburg" },
  { id: 473, position: [42.55, -88.22], type: "mine", name: "Iron Mine" },
  { id: 447, position: [42.34, -89.70], type: "city", name: "Konstanz" },
  { id: 446, position: [42.41, -91.03], type: "mine", name: "Stone Mine" },
  { id: 404, position: [42.94, -91.81], type: "city", name: "Schaffhausen" },
  { id: 752, position: [41.81, -91.74], type: "node", name: "" },
  { id: 751, position: [40.94, -91.60], type: "node", name: "" },
  { id: 753, position: [40.34, -90.82], type: "mine", name: "Gold Mine" },
  { id: 754, position: [39.64, -90.66], type: "city", name: "Schwyz" },
  { id: 2574, position: [38.44, -90.65], type: "node", name: "" },
  { id: 2575, position: [37.11, -91.56], type: "node", name: "" },
  { id: 2576, position: [36.14, -90.03], type: "node", name: "" },
  { id: 2577, position: [34.69, -90.77], type: "node", name: "" },
  { id: 2760, position: [35.61, -93.64], type: "node", name: "" },
  { id: 563, position: [35.49, -96.92], type: "city", name: "Sion" },
  { id: 562, position: [36.99, -96.89], type: "mine", name: "Iron Mine" },
  { id: 556, position: [38.37, -97.59], type: "city", name: "Fribourg" },
  { id: 557, position: [39, -98.68], type: "mine", name: "Stone Mine" },
  { id: 558, position: [39.56, -98.59], type: "node", name: "" },
  { id: 559, position: [39.65, -96.91], type: "node", name: "" },
  { id: 561, position: [38.99, -96.94], type: "mine", name: "Gold Mine" },
  { id: 560, position: [39.66, -95.89], type: "node", name: "" },
  { id: 743, position: [40.36, -95.87], type: "mine", name: "Stone Mine" },
  { id: 744, position: [40.98, -94.90], type: "city", name: "Solothurn" },
  { id: 748, position: [40.37, -94.24], type: "mine", name: "Stone Mine" },
  { id: 749, position: [39.66, -93.34], type: "city", name: "Luzern" },
  { id: 750, position: [40.51, -92.59], type: "mine", name: "Stone Mine" },
  { id: 276, position: [30.33, -95.98], type: "node", name: "" },
  { id: 275, position: [31.29, -96.72], type: "node", name: "" },
  { id: 274, position: [32.58, -96.99], type: "node", name: "" },
  { id: 565, position: [34.2, -96.94], type: "node", name: "" },
  { id: 564, position: [34.89, -96.97], type: "mine", name: "Gold Mine" },
  { id: 610, position: [46.79, -71.32], type: "mine", name: "Stone Mine" },
  { id: 609, position: [47.3, -72.04], type: "city", name: "Deggendorf" },
  { id: 612, position: [46.76, -73.13], type: "node", name: "" },
  { id: 613, position: [46.62, -74.09], type: "node", name: "" },
  { id: 614, position: [46.16, -74.81], type: "city", name: "Landshut" },
  { id: 615, position: [45.65, -75.53], type: "mine", name: "Gold Mine" },
  { id: 616, position: [45.5, -76.45], type: "city", name: "Freising" },
  { id: 617, position: [44.96, -77.61], type: "mine", name: "Stone Mine" },
  { id: 618, position: [44.21, -78.43], type: "city", name: "München" },
  { id: 1429, position: [43.13, -77.51], type: "mine", name: "Salt Mine" },
  { id: 620, position: [44.39, -79.53], type: "node", name: "" },
  { id: 621, position: [45.01, -80.94], type: "node", name: "" },
  { id: 608, position: [47.35, -73.14], type: "mine", name: "Iron Mine" },
  { id: 607, position: [47.92, -73.89], type: "mine", name: "Gold Mine" },
  { id: 606, position: [48.5, -74.76], type: "city", name: "Regensburg" },
  { id: 605, position: [48, -75.85], type: "node", name: "" },
  { id: 604, position: [47.9, -76.84], type: "mine", name: "Clay Mine" },
  { id: 619, position: [46.61, -77.46], type: "mine", name: "Iron Mine" },
  { id: 603, position: [47.33, -78.28], type: "city", name: "Ingolstadt" },
  { id: 602, position: [46.61, -80.07], type: "node", name: "" },
  { id: 601, position: [46.14, -81.13], type: "node", name: "" },
  { id: 544, position: [45.52, -81.87], type: "city", name: "Augsburg" },
  { id: 543, position: [44.72, -83.52], type: "mine", name: "Gold Mine" },
  { id: 542, position: [44.12, -84.58], type: "mine", name: "Gold Mine" },
  { id: 541, position: [43.63, -85.28], type: "city", name: "Memmingen" },
  { id: 540, position: [43.52, -86.44], type: "mine", name: "Stone Mine" },
  { id: 545, position: [45.46, -83.66], type: "mine", name: "Clay Mine" },
  { id: 546, position: [45.59, -84.44], type: "node", name: "" },
  { id: 494, position: [45.48, -85.42], type: "city", name: "Ulm" },
  { id: 493, position: [45.00, -86.40], type: "mine", name: "Gold Mine" },
  { id: 492, position: [44.9, -87.72], type: "city", name: "Zwiefalten" },
  { id: 491, position: [46.01, -88.34], type: "node", name: "" },
  { id: 411, position: [43.8, -91.77], type: "mine", name: "Iron Mine" },
  { id: 445, position: [44.39, -91.7], type: "city", name: "Rottweil" },
  { id: 448, position: [45.64, -91.64], type: "mine", name: "Iron Mine" },
  { id: 449, position: [46.18, -90.62], type: "city", name: "Zollern" },
  { id: 458, position: [46.10, -89.79], type: "node", name: "" },
  { id: 459, position: [46.68, -89.20], type: "city", name: "Reutlingen" },
  { id: 468, position: [47.21, -89.85], type: "mine", name: "Gold Mine" },
  { id: 469, position: [47.9, -90.01], type: "city", name: "Stuttgart" },
  { id: 470, position: [48.09, -88.96], type: "node", name: "" },
  { id: 472, position: [47.27, -88.42], type: "mine", name: "Stone Mine" },
  { id: 471, position: [47.90, -87.92], type: "city", name: "Esslingen" },
  { id: 985, position: [48.69, -89.99], type: "mine", name: "Iron Mine" },
  { id: 987, position: [49.63, -88.90], type: "city", name: "Heilbronn" },
  { id: 986, position: [48.53, -88.18], type: "node", name: "" },
  { id: 1002, position: [48.55, -87.17], type: "node", name: "" },
  { id: 1001, position: [49.67, -87.93], type: "node", name: "" },
  { id: 1000, position: [49.62, -86.23], type: "city", name: "Schwäbisch Hall" },
  { id: 1004, position: [50.28, -85.33], type: "mine", name: "Gold Mine" },
  { id: 1005, position: [50.73, -84.39], type: "city", name: "Rothenburg" },
  { id: 1003, position: [50.93, -85.51], type: "node", name: "Heiligenbronn" },
  { id: 1006, position: [50.31, -83.76], type: "mine", name: "Iron Mine" },
  { id: 1007, position: [50.22, -82.67], type: "city", name: "Ansbach" },
  { id: 1010, position: [49.55, -81.91], type: "mine", name: "Stone Mine" },
  { id: 1011, position: [49.05, -80.97], type: "city", name: "Eichstätt" },
  { id: 1012, position: [48.11, -79.56], type: "node", name: "" },
  { id: 1008, position: [50.86, -81.78], type: "mine", name: "Iron Mine" },
  { id: 1009, position: [51.39, -80.63], type: "city", name: "Nürnberg" },
  { id: 2769, position: [50.21, -78.46], type: "node", name: "" },
  { id: 2770, position: [49.64, -76.74], type: "node", name: "" },

  // Portugal and Spain
  { id: 1166, position: [-8.51, -168], type: "city", name: "Alcácer do Sal", eng: "Alcacer do Sal" },
  { id: 1162, position: [-7.53, -167.99], type: "mine", name: "Stone Mine" },
  { id: 1163, position: [-6.64, -167.34], type: "node", name: "" },
  { id: 1164, position: [-6.80, -166.24], type: "city", name: "Montemor" },
  { id: 1167, position: [-7.69, -164.69], type: "mine", name: "Stone Mine" },
  { id: 1168, position: [-7.68, -163.56], type: "city", name: "Évora", eng: "Evora"},
  { id: 1169, position: [-6.83, -162.83], type: "mine", name: "Gold Mine" },
  { id: 1170, position: [-5.89, -160.96], type: "city", name: "Elvas" },
  { id: 2590, position: [-3.35, -161.33], type: "node", name: "" },
  { id: 1089, position: [-4, -163.54], type: "city", name: "Crato" },
  { id: 1173, position: [-5.06, -164.37], type: "mine", name: "Gold Mine" },
  { id: 1172, position: [-4.91, -165.37], type: "city", name: "Avis" },
  { id: 1171, position: [-5.79, -165.47], type: "mine", name: "Iron Mine" },
  { id: 1161, position: [-6.76, -168.84], type: "city", name: "Setúbal", eng: "Setubal" },
  { id: 1160, position: [-6.03, -168.95], type: "node", name: "" },
  { id: 1159, position: [-5.09, -168.67], type: "node", name: "" },
  { id: 1156, position: [-4.19, -167.94], type: "city", name: "Santarém", eng: "Santarem" },
  { id: 1165, position: [-4.99, -167.21], type: "node", name: "" },
  { id: 1157, position: [-5.01, -169.67], type: "mine", name: "Iron Mine" },
  { id: 1158, position: [-5.09, -171.16], type: "city", name: "Lisboa" },
  { id: 1155, position: [-3.29, -169.01], type: "mine", name: "Clay Mine" },
  { id: 1154, position: [-1.52, -169.74], type: "city", name: "Alcobaça", eng: "Alcobaca"},
  { id: 898, position: [-0.66, -169.75], type: "mine", name: "Stone Mine" },
  { id: 897, position: [0.23, -168.92], type: "city", name: "Leiria" },
  { id: 896, position: [2.08, -168.09], type: "mine", name: "Iron Mine" },
  { id: 892, position: [3.04, -167.37], type: "city", name: "Coimbra" },
  { id: 891, position: [3.68, -168.22], type: "node", name: "" },
  { id: 889, position: [4.71, -168.66], type: "city", name: "Aveiro" },
  { id: 888, position: [4.74, -167.18], type: "mine", name: "Gold Mine" },
  { id: 893, position: [3.83, -166.28], type: "node", name: "" },
  { id: 887, position: [4.63, -165.38], type: "city", name: "Viseu" },
  { id: 894, position: [3.83, -163.73], type: "node", name: "" },
  { id: 895, position: [3.81, -161.92], type: "city", name: "Guarda" },
  { id: 899, position: [2.78, -162.02], type: "mine", name: "Stone Mine" },
  { id: 2587, position: [2.85, -160.25], type: "node", name: "" },
  { id: 927, position: [1.90, -158.48], type: "node", name: "" },
  { id: 2589, position: [-1.41, -160.44], type: "node", name: "" },
  { id: 2588, position: [0.40, -159.26], type: "node", name: "" },
  { id: 890, position: [6.37, -168.96], type: "node", name: "" },
  { id: 868, position: [7.29, -168.66], type: "city", name: "Porto" },
  { id: 869, position: [7.40, -167.03], type: "mine", name: "Iron Mine" },
  { id: 870, position: [6.6, -165.32], type: "city", name: "Lamego" },
  { id: 886, position: [5.53, -165.59], type: "mine", name: "Iron Mine" },
  { id: 867, position: [8.41, -168.22], type: "mine", name: "Stone Mine" },
  { id: 866, position: [8.94, -166.32], type: "city", name: "Braga" },
  { id: 865, position: [9.09, -164.54], type: "mine", name: "Clay Mine" },
  { id: 815, position: [9.89, -163.03], type: "city", name: "Chaves" },
  { id: 871, position: [8.01, -163.70], type: "mine", name: "Gold Mine" },
  { id: 814, position: [9.86, -161.84], type: "node", name: "" },
  { id: 699, position: [10.65, -160.21], type: "node", name: "" },
  { id: 652, position: [9.86, -159.25], type: "node", name: "" },
  { id: 651, position: [8.96, -157.56], type: "node", name: "" },
  { id: 915, position: [9.12, -155.87], type: "node", name: "" },
  { id: 914, position: [9.2, -154.78], type: "node", name: "" },
  { id: 913, position: [9.15, -153.84], type: "node", name: "" },
  { id: 926, position: [2.28, -157.39], type: "node", name: "" },
  { id: 925, position: [1.89, -155.75], type: "node", name: "" },
  { id: 924, position: [2.85, -154.82], type: "node", name: "" },
  { id: 923, position: [3.66, -154], type: "node", name: "" },
  { id: 922, position: [4.46, -153.17], type: "node", name: "" },
  { id: 921, position: [4.75, -152.23], type: "node", name: "" },
  { id: 920, position: [5.47, -151.29], type: "node", name: "" },
  { id: 919, position: [6.44, -150.51], type: "node", name: "" },
  { id: 918, position: [7.40, -149.64], type: "node", name: "" },
  { id: 917, position: [7.26, -147.82], type: "node", name: "" },
  { id: 916, position: [8.08, -146.13], type: "node", name: "" },
  { id: 912, position: [8.89, -152.33], type: "node", name: "" },
  { id: 911, position: [9.88, -151.34], type: "city", name: "Valladolid" },
  { id: 2724, position: [11.49, -149.57], type: "node", name: "" },
  { id: 1361, position: [13.35, -147.79], type: "city", name: "Burgos" },
  { id: 2578, position: [14.3, -146.27], type: "node", name: "" },
  { id: 2579, position: [15.81, -145.33], type: "port", name: "" },
  { id: 2580, position: [16.89, -146.01], type: "node", name: "" },
  { id: 2581, position: [18.36, -145.29], type: "node", name: "" },
  { id: 2582, position: [20.19, -145.46], type: "node", name: "" },
  { id: 910, position: [10.2, -150.52], type: "mine", name: "Iron Mine" },
  { id: 909, position: [9.8, -149.56], type: "node", name: "" },
  { id: 908, position: [9.02, -147.89], type: "city", name: "Aranda de Duero" },
  { id: 1358, position: [10.76, -148.11], type: "node", name: "" },
  { id: 1359, position: [11.64, -147.78], type: "node", name: "" },
  { id: 1360, position: [12.26, -148.11], type: "mine", name: "Gold Mine" },
  { id: 2725, position: [11.66, -145.28], type: "node", name: "" },
  { id: 907, position: [9.16, -146.15], type: "mine", name: "Gold Mine" },
  { id: 905, position: [9, -144.32], type: "city", name: "Osma" },
  { id: 906, position: [8.9, -143.28], type: "port", name: "" },
  { id: 904, position: [10.01, -143.60], type: "mine", name: "Iron Mine" },
  { id: 903, position: [10.74, -142.66], type: "city", name: "Soria" },
  { id: 902, position: [9.15, -141.77], type: "port", name: "" },
  { id: 901, position: [8.23, -141.80], type: "port", name: "" },
  { id: 2726, position: [11.69, -140.78], type: "node", name: "" },
  { id: 2727, position: [14.22, -140.90], type: "port", name: "" },
  { id: 2728, position: [15.89, -139.03], type: "node", name: "" },
  { id: 2729, position: [18.21, -139.04], type: "node", name: "" },
  { id: 2730, position: [20.12, -137.36], type: "node", name: "" },
  { id: 2591, position: [7.18, -142.45], type: "node", name: "" },
  { id: 2592, position: [5.47, -142.68], type: "node", name: "" },
  { id: 2593, position: [3.64, -143.43], type: "node", name: "" },
  { id: 2594, position: [1.99, -143.30], type: "port", name: "" },
  { id: 2595, position: [1.15, -142.51], type: "node", name: "" },
  { id: 2596, position: [1.13, -141.22], type: "port", name: "" },
  { id: 2597, position: [-5.34, -141.44], type: "node", name: "" },
  { id: 2598, position: [-5.24, -139.86], type: "node", name: "" },
  { id: 2599, position: [-5.28, -138.37], type: "port", name: "" },
  { id: 900, position: [8.25, -140.03], type: "node", name: "" },
  { id: 928, position: [8.00, -138.15], type: "node", name: "" },
  { id: 718, position: [8.08, -136.38], type: "city", name: "Calatayud" },
  { id: 2583, position: [6.50, -136.27], type: "node", name: "" },
  { id: 2584, position: [5.37, -135.45], type: "node", name: "" },
  { id: 2585, position: [4.69, -134.02], type: "node", name: "" },
  { id: 2586, position: [3.08, -134.05], type: "node", name: "" },
  { id: 813, position: [2.01, -132.93], type: "mine", name: "Stone Mine" },
  { id: 806, position: [1.14, -132.08], type: "city", name: "Segorbe" },
  { id: 807, position: [0.16, -131.87], type: "mine", name: "Clay Mine" },
  { id: 808, position: [-1.47, -132.41], type: "city", name: "Valencia" },
  { id: 809, position: [-3.15, -132.83], type: "mine", name: "Gold Mine" },
  { id: 810, position: [-4.12, -132.86], type: "city", name: "Játiva" },
  { id: 811, position: [-4.85, -131.78], type: "mine", name: "Stone Mine" },
  { id: 812, position: [-4.98, -130.28], type: "city", name: "Dénia" },
  { id: 805, position: [1.00, -131.14], type: "mine", name: "Iron Mine" },
  { id: 804, position: [2, -130.26], type: "city", name: "Castellón" },
  { id: 803, position: [3.06, -129.57], type: "port", name: "" },
  { id: 802, position: [3.69, -129.35], type: "node", name: "" },
  { id: 599, position: [4.68, -128.54], type: "city", name: "Tortosa" },
];
